import { resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-d-flex" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, " @ ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DateFormatted = _resolveComponent("DateFormatted")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_CurrencyText = _resolveComponent("CurrencyText")!
  const _component_AppTable = _resolveComponent("AppTable")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_AppTable, {
    ref: "dataTable",
    "striped-rows": false,
    filtersSchema: _ctx.filters,
    service: _ctx.service,
    showActions: false,
    showHeader: false,
    sortField: `date_at`,
    sortOrder: 1
  }, {
    columns: _withCtx(({onApplyFilter}) => [
      _createVNode(_component_Column, { header: "Actions" }, {
        body: _withCtx(({data}) => [
          _createElementVNode("div", _hoisted_1, [
            _withDirectives(_createVNode(_component_Button, {
              type: "button",
              disabled: _ctx.requestPending,
              icon: "pi pi-download",
              class: "p-mt-0 p-button-outlined",
              onClick: ($event: any) => (_ctx.downloadInvoices(data.id))
            }, null, 8, ["disabled", "onClick"]), [
              [_directive_tooltip, 'Download ledgers']
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_Column, {
        field: "date_at",
        header: "Date",
        sortable: true,
        style: {"min-width":"8rem"}
      }, {
        body: _withCtx(({data}) => [
          _createVNode(_component_DateFormatted, {
            date: data.date_at,
            format: "YYYY-MM-DD"
          }, null, 8, ["date"])
        ]),
        _: 1
      }),
      _createVNode(_component_Column, {
        header: "Period",
        style: {"min-width":"15rem"}
      }, {
        body: _withCtx(({ data }) => [
          _createVNode(_component_DateFormatted, {
            date: data.inv_movement.from_period_at,
            format: "YYYY-MM-DD"
          }, null, 8, ["date"]),
          _hoisted_2,
          _createVNode(_component_DateFormatted, {
            date: data.inv_movement.to_period_at,
            format: "YYYY-MM-DD"
          }, null, 8, ["date"])
        ]),
        _: 1
      }),
      _createVNode(_component_Column, {
        header: "Type",
        field: "type",
        showFilterMatchModes: false,
        showFilterOperator: false
      }, {
        body: _withCtx(({data}) => [
          _createTextVNode(_toDisplayString(_ctx.$t(`invoices.type_${data.type}`)), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_Column, {
        field: "num",
        header: "Num."
      }),
      _createVNode(_component_Column, {
        field: "mov_id",
        header: "Mov.",
        showFilterMatchModes: false
      }, {
        filter: _withCtx(({filterModel, filterCallback}) => [
          _createVNode(_component_InputText, {
            modelValue: filterModel.value,
            "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
            placeholder: "Search by movement",
            onKeyup: _withKeys(($event: any) => (onApplyFilter(filterCallback)), ["enter"])
          }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeyup"])
        ]),
        filterclear: _withCtx(({filterCallback}) => [
          _createVNode(_component_Button, {
            label: _ctx.$t('common.clear'),
            class: "p-button-outlined",
            onClick: ($event: any) => (onApplyFilter(filterCallback))
          }, null, 8, ["label", "onClick"])
        ]),
        filterapply: _withCtx(({filterCallback}) => [
          _createVNode(_component_Button, {
            label: _ctx.$t('common.apply'),
            class: "p-button-success",
            onClick: ($event: any) => (onApplyFilter(filterCallback))
          }, null, 8, ["label", "onClick"])
        ]),
        _: 2
      }, 1024),
      _createVNode(_component_Column, {
        style: {"min-width":"10rem"},
        field: "business_name",
        header: "Business name",
        showFilterMatchModes: false
      }, {
        filter: _withCtx(({filterModel, filterCallback}) => [
          _createVNode(_component_InputText, {
            modelValue: filterModel.value,
            "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
            placeholder: "Search by name",
            onKeyup: _withKeys(($event: any) => (onApplyFilter(filterCallback)), ["enter"])
          }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeyup"])
        ]),
        filterclear: _withCtx(({filterCallback}) => [
          _createVNode(_component_Button, {
            label: _ctx.$t('common.clear'),
            class: "p-button-outlined",
            onClick: ($event: any) => (onApplyFilter(filterCallback))
          }, null, 8, ["label", "onClick"])
        ]),
        filterapply: _withCtx(({filterCallback}) => [
          _createVNode(_component_Button, {
            label: _ctx.$t('common.apply'),
            class: "p-button-success",
            onClick: ($event: any) => (onApplyFilter(filterCallback))
          }, null, 8, ["label", "onClick"])
        ]),
        _: 2
      }, 1024),
      _createVNode(_component_Column, {
        style: {"min-width":"10rem"},
        field: "business_address",
        header: "Business address",
        showFilterMatchModes: false
      }, {
        filter: _withCtx(({filterModel, filterCallback}) => [
          _createVNode(_component_InputText, {
            modelValue: filterModel.value,
            "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
            placeholder: "Search by address",
            onKeyup: _withKeys(($event: any) => (onApplyFilter(filterCallback)), ["enter"])
          }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeyup"])
        ]),
        filterclear: _withCtx(({filterCallback}) => [
          _createVNode(_component_Button, {
            label: _ctx.$t('common.clear'),
            class: "p-button-outlined",
            onClick: ($event: any) => (onApplyFilter(filterCallback))
          }, null, 8, ["label", "onClick"])
        ]),
        filterapply: _withCtx(({filterCallback}) => [
          _createVNode(_component_Button, {
            label: _ctx.$t('common.apply'),
            class: "p-button-success",
            onClick: ($event: any) => (onApplyFilter(filterCallback))
          }, null, 8, ["label", "onClick"])
        ]),
        _: 2
      }, 1024),
      _createVNode(_component_Column, {
        style: {"min-width":"5rem"},
        field: "business_city",
        header: "Business city",
        showFilterMatchModes: false
      }, {
        filter: _withCtx(({filterModel, filterCallback}) => [
          _createVNode(_component_InputText, {
            modelValue: filterModel.value,
            "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
            placeholder: "Search by city",
            onKeyup: _withKeys(($event: any) => (onApplyFilter(filterCallback)), ["enter"])
          }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeyup"])
        ]),
        filterclear: _withCtx(({filterCallback}) => [
          _createVNode(_component_Button, {
            label: _ctx.$t('common.clear'),
            class: "p-button-outlined",
            onClick: ($event: any) => (onApplyFilter(filterCallback))
          }, null, 8, ["label", "onClick"])
        ]),
        filterapply: _withCtx(({filterCallback}) => [
          _createVNode(_component_Button, {
            label: _ctx.$t('common.apply'),
            class: "p-button-success",
            onClick: ($event: any) => (onApplyFilter(filterCallback))
          }, null, 8, ["label", "onClick"])
        ]),
        _: 2
      }, 1024),
      _createVNode(_component_Column, {
        style: {"min-width":"5rem"},
        field: "business_zip",
        header: "Business zip",
        showFilterMatchModes: false
      }, {
        filter: _withCtx(({filterModel, filterCallback}) => [
          _createVNode(_component_InputText, {
            modelValue: filterModel.value,
            "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
            placeholder: "Search by zip",
            onKeyup: _withKeys(($event: any) => (onApplyFilter(filterCallback)), ["enter"])
          }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeyup"])
        ]),
        filterclear: _withCtx(({filterCallback}) => [
          _createVNode(_component_Button, {
            label: _ctx.$t('common.clear'),
            class: "p-button-outlined",
            onClick: ($event: any) => (onApplyFilter(filterCallback))
          }, null, 8, ["label", "onClick"])
        ]),
        filterapply: _withCtx(({filterCallback}) => [
          _createVNode(_component_Button, {
            label: _ctx.$t('common.apply'),
            class: "p-button-success",
            onClick: ($event: any) => (onApplyFilter(filterCallback))
          }, null, 8, ["label", "onClick"])
        ]),
        _: 2
      }, 1024),
      _createVNode(_component_Column, {
        style: {"min-width":"5rem"},
        field: "business_country",
        header: "Business country",
        showFilterMatchModes: false
      }, {
        filter: _withCtx(({filterModel, filterCallback}) => [
          _createVNode(_component_InputText, {
            modelValue: filterModel.value,
            "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
            placeholder: "Search by country",
            onKeyup: _withKeys(($event: any) => (onApplyFilter(filterCallback)), ["enter"])
          }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeyup"])
        ]),
        filterclear: _withCtx(({filterCallback}) => [
          _createVNode(_component_Button, {
            label: _ctx.$t('common.clear'),
            class: "p-button-outlined",
            onClick: ($event: any) => (onApplyFilter(filterCallback))
          }, null, 8, ["label", "onClick"])
        ]),
        filterapply: _withCtx(({filterCallback}) => [
          _createVNode(_component_Button, {
            label: _ctx.$t('common.apply'),
            class: "p-button-success",
            onClick: ($event: any) => (onApplyFilter(filterCallback))
          }, null, 8, ["label", "onClick"])
        ]),
        _: 2
      }, 1024),
      _createVNode(_component_Column, {
        field: "total_amount",
        header: "Tot. amount.",
        style: {"min-width":"8rem"}
      }, {
        body: _withCtx(({ data }) => [
          _createVNode(_component_CurrencyText, {
            modelValue: data.total_amount
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["filtersSchema", "service"]))
}